'use client';
import { createComponent } from "../internals/utils/index.js";
var DrawerActions = createComponent({
  name: 'DrawerActions'
});
export default DrawerActions;